module.exports = {
      id: "double-arrow-usage",
      viewBox: "0 0 21.133 19.508",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#double-arrow",
      toString: function () {
        return this.url;
      }
    }